import { generalEnv } from '@nx-frontend/shared/env';

/**
 * Some images are stored in DB as full URLs to box/file, this function will replace the URL with the static asset prefix
 * @param url
 * @param staticAssetPrefix
 * @returns
 */
export const getFixedImageUrl = (url: string): string => {
  let fixedUrl = url;
  /**
   * Some images are stored in DB with path to dev-thefusebase.com doman,
   * in this case shold not replace the URL with the static asset prefix
   */
  const devDomain = /dev-thefusebase\.com/g;

  if (url.match(/box\/file/) && !url.match(devDomain)) {
    const [, storedFileUUID] = url.split('/box/file/');
    if (storedFileUUID) {
      fixedUrl = `${generalEnv.staticAssetPrefix}${storedFileUUID}`;
    }
  }
  return fixedUrl;
};
